import { cloneDeep } from "lodash";

function unsetFilters(filters) {
  if (!filters) return null;

  const output = cloneDeep(filters).map(initialFilter => {
    initialFilter.filters.forEach(filter => {
      if (filter.type === "range") {
        filter.value = null;
        filter.from = null;
        filter.to = null;
      } else {
        filter.value = null;
      }
    });
    return initialFilter;
  });

  return output;
}

export { unsetFilters };
